import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './about.css'

class About extends React.Component{
    render(){
        return(
            <>
            <div className="aboutus-section" id="aboutt">
        <div className="container">
            <div className="row">
                <div className="col-md-3 col-sm-6 col-xs-12">
                    <div className="aboutus">
                        <h2 className="aboutus-title">About me</h2>
                        <p className="aboutus-text">
                        My name is Jasnel JUILLET and I am a web developer,
                        I'm currently based in Haiti, Delmas 32. 
                        My main focus lies on the front-end, JavaScript and React development
                        </p>
                        <p className="aboutus-text">
                        I also have rich experience as a backend developer, 
                        mostly in (MongoDB, ExpressJS, Node.js) stack.
                        </p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 col-xs-12">
                    <div className="aboutus-banner">
                        <img src="file.enc.jpg" alt="Jasnel " id="pht" />
                    </div>
                </div>
                <div className="col-md-5 col-sm-6 col-xs-12">
                    <div className="feature">
                      <div className="feature-box">
                            <div className="clearfix">
                                <div className="iconset">
                                </div>
                                <div className="feature-content">
                                    <h4>Freecodecamp / Udemy / Sololearn</h4>
                                    <p>in these platforms I have received good understanding, individual and large group practice and certificates held in these areas.</p>
                                </div>
                            </div>
                        </div> 
                         <div className="feature-box">
                            <div className="clearfix">
                                <div className="iconset">                                    
                                </div>
                                <div className="feature-content">
                                    <h4>Mentoring</h4>
                                    <p>famous person who serves me as a guide, who directs me in the right way, in my research and my orientations. <strong>Ashley Narcisse (darkfadr) /Jean Gerard Bousiquot (JGB Solutions)</strong> </p>
                                </div>
                            </div>
                        </div> 
                         <div className="feature-box">
                            <div className="clearfix">
                                <div className="iconset">
                                </div>
                                <div className="feature-content">
                                    <h4></h4>
                                    <p></p>
                                </div>
                            </div>
                        </div>       
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
        )
    }
}
export default About;
